/** Tarihçe sayfası görseli */
export const HISTORY_IMAGE_SRC =
    'https://istanbulrotary.org/img/db/resim1-3.jpg';
